export default __webpack_public_path__ + "static/media/37.5b40bfd8.png";